export default __webpack_public_path__ + "static/media/investorSteveJobs.dba8e078.wav";